import { ReactElement } from 'react';
import { t } from '../../common/getTranslations';
import { requestContext } from '../../common/requestContext';
import { Layout } from '../../design-system/layout/Layout';
import { AskPageContainer } from '../../domain/ask/container/AskPageContainer';
import { CommonMobileHeaderType } from '../../header/constants';
function Ask() {
  return <AskPageContainer />;
}
Ask.getLayout = function getLayout(page: ReactElement) {
  const requestInfo = requestContext.requestInfo;
  const shouldShowHeader = requestInfo?.display ? !requestInfo.display.isWebView : true;
  return <Layout title={t('more_customer_cs_title')} mobileLayoutConfig={{
    shouldShowHeader,
    headerType: CommonMobileHeaderType.FourDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: false
  }}>
      {page}
    </Layout>;
};
export default Ask;